import gql from 'graphql-tag';

export default gql`
  query LessonRelativeStatus($lessonId: MongoID, $filter: LessonRelativeStatusFilterInput) {
    lessonRelativeStatus(lessonId: $lessonId, filter: $filter) {
      lessonId
      status
      videoCallStatus
      index
      previousLessonVideoCallStatus
      lesson {
        _id
        alias
        videoCallStatus
        lessonExercises {
          _id
        }
        data {
          isZeroLesson
        }
      }
    }
  }
`;
